import React from "react";
import { Outlet } from "react-router-dom";

const RenderRoute = () => {
  return <Outlet />;
};

export default RenderRoute;
